import React, { Component } from 'react';

export default class TableHead extends Component {
    render() {
        const style = {
            padding: '20px 30px',
            border: '1px solid #EEE',
            backgroundColor: '#F8FAFC',
            textTransform: 'capitalize'
        };

        return (
            <thead>
                <tr>
                    {this.props.rows.map(function(row, i){
                        return <td style={style} key={i}>{row}</td>;
                    })}
                </tr>
            </thead>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/TableHead.js